import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { WebApiError } from "./WebApiError";
// Error class abstraction that enables framework agnostic error handling
export var WebApiNetworkError = /*#__PURE__*/ function(WebApiError) {
    "use strict";
    _inherits(WebApiNetworkError, WebApiError);
    function WebApiNetworkError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        _class_call_check(this, WebApiNetworkError);
        var _this;
        _this = _call_super(this, WebApiNetworkError, [
            message,
            undefined,
            undefined
        ]), // Always undefined for this type of error
        _this.httpStatusCode = undefined, _this.name = "WebApiNetworkError";
        return _this;
    }
    return WebApiNetworkError;
}(WebApiError);
